const FILLCOLOR = '#fff' // 填充颜色
const STROKESTYLE = 'rgba(0,0,0,0.12)' // 边框颜色
import rotate from '@com/assets/stage/rotate.png'

import lighting from '@com/assets/stage/lighting.png'
function getDraw(drawFunc) {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  ctx.fillStyle = FILLCOLOR
  ctx.strokeStyle = STROKESTYLE
  ctx.beginPath()
  drawFunc(ctx)
  ctx.closePath()
  ctx.fill()
  ctx.stroke()
  return canvas
}

export const topRightFactory = () => {
  return getDraw((ctx) => {
    ctx.translate(12.5, 12.5)
    ctx.lineTo(6, 0)
    ctx.lineTo(6, 6)
    ctx.lineTo(0, 6)
    ctx.lineTo(0, 0)
    ctx.lineWidth = 2
  })
}

export const topRight = topRightFactory()

export const topRightWithLighting = (() => {
  const canvas = topRightFactory()
  const ctx = canvas.getContext('2d')
  const img = new Image()
  img.onload = function () {
    ctx.drawImage(img, 24, 24, 64, 64, -12.5, 5, 16, 16)
  }
  img.src = lighting
  return canvas
})()

const getIcon = () => {
  const canvas = document.createElement('canvas')
  canvas.height = 30
  canvas.width = 30
  const ctx = canvas.getContext('2d')
  ctx.fillStyle = FILLCOLOR
  ctx.strokeStyle = STROKESTYLE
  ctx.arc(15, 15, 12, 0, 2 * Math.PI)
  ctx.fill()
  ctx.stroke()
  const img = new Image()
  img.onload = function () {
    ctx.drawImage(img, 3, 3)
  }
  img.src = rotate
  return canvas
}
export const iconStyle = getIcon()

export const setAnchorsStyle = (node, className, style) => {
  const anchorNode = node.findOne(className)
  // 使用图案填充
  anchorNode.fillPriority('pattern')
  anchorNode.fillPatternImage(style)
  // 去边框
  anchorNode.strokeEnabled(false)
  anchorNode.scaleX(1)
  anchorNode.scaleY(1)
}

// 重新设置锚点的尺寸
export const setAnchorSize = (node, className, size) => {
  const anchorNode = node.findOne(className)

  if (!anchorNode) return

  // 重置图案填充设置方式
  anchorNode.fillPriority('color')
  anchorNode.strokeEnabled(true)
  // 因为只要触发了 transform 每一帧都会拿 anchorSize 去更新锚点的尺寸，所以只能通过 scale 的值来改动锚点
  if (anchorNode.width()) {
    const scale = size / anchorNode.width()
    anchorNode.scaleX(scale)
    anchorNode.scaleY(scale)
  } else {
    anchorNode.scaleX(1)
    anchorNode.scaleY(1)
  }
}

export const initAnchorsStyle = (tr, options = {}) => {
  // 获取对应节点，并设置对应的样式
  // setAnchorsStyle(tr, '.top-left', topLeft)
  if (options.lighting) {
    setAnchorsStyle(tr, '.top-right', topRightWithLighting)
  } else {
    setAnchorSize(tr, '.top-right', 6)
  }

  setAnchorSize(tr, '.top-left', 6)
  setAnchorSize(tr, '.top-center', 6)
  setAnchorSize(tr, '.bottom-left', 6)
  setAnchorSize(tr, '.bottom-center', 6)
  setAnchorSize(tr, '.bottom-right', 6)

  setAnchorSize(tr, '.middle-left', 6)
  setAnchorSize(tr, '.middle-right', 6)

  setAnchorsStyle(tr, '.rotater', iconStyle)
  tr.getLayer().batchDraw()
}
